// src/pages/notFound.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

// ===== MUI =====
import {
  Box,
  Typography,
  Stack,
  Button,
} from "@mui/material";

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box className="pageContainer">
      <Stack
        spacing={3}
        sx={{
          alignItems: "center",
          textAlign: "center",
          mt: { xs: 5, md: 8 },
        }}
      >
        {/* Ilustración */}
        <Box
          component="img"
          src="/404.png"
          alt="Página no encontrada"
          sx={{
            width: "100%",
            maxWidth: 340,
            opacity: 0.95,
          }}
        />

        {/* Texto */}
        <Stack spacing={1.5} sx={{ maxWidth: 520 }}>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            Página no encontrada
          </Typography>

          <Typography sx={{ color: "text.secondary" }}>
            La página que intentas abrir no existe, ha sido eliminada
            o no tienes permisos para acceder a ella.
          </Typography>
        </Stack>

        {/* Acciones */}
        <Stack direction="row" spacing={2}>
          <Button variant="outlined" onClick={() => navigate(-1)}>
            Volver atrás
          </Button>

          <Button onClick={() => navigate("/app/inicio")}>
            Ir al inicio
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default NotFound;
